// extracted by mini-css-extract-plugin
export default {"trusted":"TrustedAbout_trusted__wl0Hk","text":"TrustedAbout_text__CSppS"};